import { useRef } from 'react';

type Props = {
  html: string;
  onChangeHtml: (html: string) => void;
  isGridVisible: boolean;
};

const PageA4Block = ({ html, onChangeHtml, isGridVisible }: Props) => {
  const pageRef = useRef<HTMLDivElement>(null);

  return (
    <div className="flex justify-center items-start py-8 px-4 h-full overflow-auto bg-neutral-100 dark:bg-neutral-900">
      <div className="relative">
        {isGridVisible && (
          <div className="absolute inset-0 pointer-events-none z-10 bg-[linear-gradient(to_right,#D9D9DE_1px,transparent_1px),linear-gradient(to_bottom,#D9D9DE_1px,transparent_1px)] [background-size:10px_10px]" />
        )}

        {isGridVisible && (
          <div className="absolute inset-0 flex items-center justify-center pointer-events-none z-10">
            <div className="w-[1px] h-full bg-blue-500 opacity-70" />
            <div className="absolute top-1/2 left-0 right-0 h-[1px] bg-blue-500 opacity-70" />
          </div>
        )}

        <div
          ref={pageRef}
          className="page-content w-[49.375rem] h-[70rem] rounded-sm bg-white border border-neutral-200 dark:border-neutral-800 shadow outline-none overflow-auto relative z-0"
          contentEditable
          suppressContentEditableWarning
          dangerouslySetInnerHTML={{ __html: html }}
          onInput={(e) => onChangeHtml((e.currentTarget as HTMLDivElement).innerHTML)}
        />
      </div>
    </div>
  );
};

export default PageA4Block;
